module.exports = __webpack_public_path__ + "img/noMessage.efde90e3.svg";